import { render, staticRenderFns } from "./g-audio.vue?vue&type=template&id=7dcffbc0&scoped=true&"
import script from "./g-audio.vue?vue&type=script&lang=ts&"
export * from "./g-audio.vue?vue&type=script&lang=ts&"
import style0 from "./g-audio.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"
import style1 from "./g-audio.vue?vue&type=style&index=1&id=7dcffbc0&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcffbc0",
  null
  
)

export default component.exports